/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: AlignmentController.tsx
 * Project: mle-client-n
 * Committed last: 2022/1/30 @ 1752
 * ---
 * Description:
 */

import {
  HorizontalAlignment
}                                                  from '@revodigital/pamela/lib/configuration/Alignment';
import { ButtonGroup, FormGroup, PopoverPosition } from '@blueprintjs/core';
import React               from 'react';
import { AlignmentButton } from './AlignmentButton';
import { observer }        from 'mobx-react';

interface Props {
  observableValue: HorizontalAlignment;
  setter: (value: HorizontalAlignment) => void;
  title: string;
  className?: string;
  enableJustify?: boolean;
}

/**
 * Selettore per gestire l'allineamento orizzontale di un testo
 */
export const AlignmentController = observer((props: Props) => {
  return (
    <div className={ props.className }>
      <FormGroup
        label={ props.title }
      >
        <ButtonGroup>
          <AlignmentButton icon={ 'align-left' }
                           currentAlignment={ props.observableValue }
                           expectedAlignment={ HorizontalAlignment.Left }
                           setter={ props.setter }
                           tooltip={ 'Allinea a sinistra' }/>

          <AlignmentButton icon={ 'align-center' }
                           currentAlignment={ props.observableValue }
                           expectedAlignment={ HorizontalAlignment.Center }
                           setter={ props.setter }
                           tooltip={ 'Allinea al centro' }
                           tooltipPosition={ PopoverPosition.BOTTOM }/>

          <AlignmentButton icon={ 'align-right' }
                           currentAlignment={ props.observableValue }
                           expectedAlignment={ HorizontalAlignment.Right }
                           setter={ props.setter }
                           tooltip={ 'Allinea a destra' }
                           tooltipPosition={ PopoverPosition.BOTTOM_LEFT }
          />

          {
            props.enableJustify && <AlignmentButton icon={ 'align-justify' }
                                                    currentAlignment={ props.observableValue }
                                                    expectedAlignment={ HorizontalAlignment.Justify }
                                                    setter={ props.setter }
                                                    tooltip={ 'Giustifica' }
                                                    tooltipPosition={ PopoverPosition.RIGHT }
                                />
          }
        </ButtonGroup>
      </FormGroup>
    </div>
  );
});